<script>
  import DonorSearch from "$lib/components/Contributors/DonorSearch.svelte";
  import { getContext } from "svelte";
  import {
    sortVirtualSupporters,
    filterVirtualSupporters
  } from "$lib/utilities/contentTypes/virtualSupporters.js";

  const virtualSupporters = getContext("virtualSupporters");
  const filteredSupporters = filterVirtualSupporters(virtualSupporters);
  const sortedVirtualSupporters = sortVirtualSupporters(filteredSupporters);
</script>

<DonorSearch lowTierContributors={sortedVirtualSupporters} id="virtualSupportersList" />
